var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlertFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.14.678a5.174 5.174 0 0 1 1.943 1.906l14.23 24.434c1.43 2.455.555 5.579-1.954 6.978a5.319 5.319 0 0 1-2.589.67H5.23c-2.889 0-5.23-2.29-5.23-5.115 0-.893.239-1.77.692-2.544l14.31-24.434C16.439.122 19.635-.727 22.14.678zm-2.646 24.424c-1.13 0-2.046.896-2.046 2.002 0 1.105.916 2.002 2.046 2.002s2.046-.897 2.046-2.002c0-1.106-.916-2.002-2.046-2.002zm.542-15.57h-1.084c-.58 0-1.05.469-1.05 1.048v11.248c0 .58.47 1.05 1.05 1.05h1.084c.58 0 1.05-.47 1.05-1.05V10.58c0-.58-.47-1.049-1.05-1.049z",
    id: "kebmiuv5wa"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#kebmiuv5wa",
    transform: "translate(6.5 8.667)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertFill);
export default __webpack_public_path__ + "static/media/icon-alert-fill.f5f890a6.svg";
export { ForwardRef as ReactComponent };